var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTbankPartnerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 89,
    viewBox: "0 0 242 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 21.7439H92.5122V44.1303C92.5122 49.8692 89.4507 55.1723 84.4809 58.0421L70.2561 66.2561L56.0313 58.0421C51.0615 55.1723 48 49.8692 48 44.1303V21.7439Z",
    fill: "#115EF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4634 33.3171V40.4189C61.4343 39.3222 63.1995 38.58 65.2178 38.58H67.4111V46.8358C67.4111 49.0322 66.8145 50.9547 65.9293 52.0122H75.4698C74.5864 50.9537 73.9912 49.0336 73.9912 46.84V38.58H76.1846C78.2029 38.58 79.9681 39.3222 80.939 40.4189V33.3171H60.4634Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.195 52.0122V33.3171H122.25V37.5899H108.877V40.2612H115.497C120.187 40.2612 123.671 41.3294 123.671 46.1363C123.671 50.944 120.187 52.0122 115.497 52.0122H103.195ZM108.877 44.534V47.7386H115.523C117.453 47.7386 117.908 47.3654 117.908 46.1363C117.908 44.908 117.453 44.534 115.523 44.534H108.877Z",
    fill: "#115EF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M154.228 45.068V52.0121H148.597V33.317H154.228V40.1276H163.443V33.317H169.073V52.0121H163.443V45.068H154.228Z",
    fill: "#115EF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M178.199 44.961V52.0121H172.634V33.317H178.199V40.2877H181.532L187.333 33.317H193.632L186.362 42.05V42.3975L194 52.0121H187.097L181.506 44.961H178.199Z",
    fill: "#115EF3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M139.848 49.2612H131.271L130.313 52.0121H124.561L131.738 33.317H139.666L146.817 52.0121H140.806L139.848 49.2612ZM138.371 44.9884L135.832 37.6172H135.365L132.774 44.9884H138.371Z",
    fill: "#115EF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTbankPartnerLogo);
export default __webpack_public_path__ + "static/media/tbank-partner-logo.3b215f9fd5be1da7ce84e9e1162249ca.svg";
export { ForwardRef as ReactComponent };